export const config = {
  height: 500,
  menubar: false,
  toolbar_mode: "wrap" as const,
  plugins: [
    "advlist",
    "autolink",
    "lists",
    "link",
    "image",
    "charmap",
    "preview",
    "anchor",
    "searchreplace",
    "visualblocks",
    "code",
    "insertdatetime",
    "media",
    "table",
    "help",
    "wordcount",
  ],

  toolbar: `
  blocks fontfamily fontsize |
  bold italic underline strikethrough blockquote |
  forecolor backcolor |
  link image media table |
  align lineheight |
  numlist bullist indent outdent |
  charmap |
  removeformat`,

  content_style: `@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap');
    body { font-family: Oswald; color: #333; background-color: #fff;}`,
  font_family_formats: `Andale Mono=andale mono,times; 
    Arial=arial,helvetica,sans-serif; 
    Arial Black=arial black,avant garde; 
    Book Antiqua=book antiqua,palatino; 
    Comic Sans MS=comic sans ms,sans-serif; 
    Courier New=courier new,courier; 
    Georgia=georgia,palatino; 
    Helvetica=helvetica; 
    Impact=impact,chicago; 
    Oswald=oswald; 
    Symbol=symbol; 
    Tahoma=tahoma,arial,helvetica,sans-serif; 
    Terminal=terminal,monaco; 
    Times New Roman=times new roman,times; 
    Trebuchet MS=trebuchet ms,geneva; 
    Verdana=verdana,geneva; 
    Webdings=webdings; 
    Wingdings=wingdings,zapf dingbats`,
};
